module.exports = __webpack_public_path__ + "static/media/not_quite_right_icon.a8d7845a.svg";